import AccessCodes from './AccessCodes';

export default AccessCodes;
